export const RRS_PROPERTY_VALUE = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Boligverdi',
  url: 'https://scoopr.no/boligverdi',
  description: 'Sjekk hva boligen din er verdt',
  datePublished: '2023-05-04T08:00:00+00:00',
  dateModified: '2023-05-04T08:00:00+00:00',
};
